import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { ChancenwerkUser } from '../entities/ChancenwerkUser.js';

export const setSavedCampusSections = registerMutation({
  type: () => Boolean,
  operationName: 'findSimilarOSAcquisitionStudent',
  resolve: (sectionIDs: string[]) => {
    return async () => {
      const user = await CurrentUserInfo.getMyself<ChancenwerkUser>()({ _id: 1 });
      if (!user) throw new Error('Eingeloggten Nutzer nicht gefunden');

      const collection = await getRawCollection<ChancenwerkUser>(ChancenwerkUser._collectionName);
      const res = await collection.updateOne(
        {
          _id: user._id,
        },
        {
          $set: {
            savedCampusSectionIDs: sectionIDs,
          },
        },
      );
      return res.upsertedCount === 1;
    };
  },
  options: {},
  params: [{ type: () => [String], name: 'sectionIDs' }],
});
